import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import GroupSubNav from "../../components/layout/GroupSubNav";
import HeaderNavigation from "../../components/layout/HeaderNavigation";
import StoryFormModal from "../../components/modals/StoryFormModal";
import { getStoriesApi } from "../../store/actions/storiesActions";
import { scrollToTop } from "../../utils/scrollToTop";
import ShareStorySection from "./components/ShareStorySection";
import StoriesHeader from "./components/StoriesHeader";
import StoriesListing from "./components/StoriesListing";
import StoryCtaSection from "./components/StoryCtaSection";
import SiteFooter from "../../components/layout/SiteFooter";

const Stories = () => {
  const [stories, setStories] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchData = async (params) => {
    setLoading(true);
    try {
      const response = await getStoriesApi(params);
      setStories(response?.data);
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  useEffect(() => {
    scrollToTop();
    const params = {
      approve: true,
      limit: 10000,
    };
    fetchData(params);
  }, []);

  const [show, setShow] = useState(false);
  const handleShowForm = () => {
    setShow(true);
  };

  const handleClose = () => {
    setShow(false);
  };

  return (
    <div>
      <Helmet>
        <title>
          Utiva Talent Stories | Real People Building New Possibilities
        </title>
        <meta
          name="description"
          content="Explore Talent Stories from people building practical skills, projects and career confidence across data, product, business and technology."
        />
        <meta property="og:title" content="Utiva Talent Stories" />
        <meta
          property="og:description"
          content="Real people. Practical learning. Visible progress."
        />
        <meta property="og:url" content={window.location.href} />
        <meta property="og:type" content="website" />
      </Helmet>

      <header className="w-full relative">
        <HeaderNavigation />
      </header>
      <GroupSubNav />

      <main>
        <StoriesHeader stories={stories} handleShowForm={handleShowForm} />
        <StoriesListing stories={stories} loading={loading} />
        <ShareStorySection handleShowForm={handleShowForm} />
        <StoryCtaSection />
      </main>

      <SiteFooter />

      {show && <StoryFormModal show={show} handleModalClose={handleClose} />}
    </div>
  );
};

export default Stories;
